import { defineStore } from 'pinia'

export const useOverlayStore = defineStore('overlay', () => {
  const settings = ref(null)
  const mobile = ref(null)
  const desktop = ref(null)
  const activeAppModal = ref(null)
  const activeAppModalTransition = ref(null)
  const activeAppModalOptions = ref(null)
  const activeAppTray = ref(null)
  const activeAppTrayTransition = ref(null)
  const activeAppTrayOptions = ref(null)
  const activeFlyIn = ref(null)
  const activeFlyInTransition = ref(null)
  const activeFlyInOptions = ref(null)
  const eventImagesModalIsActive = ref(false)

  const overlayIsActive = computed(() => Boolean(activeAppModal.value || activeAppTray.value || activeFlyIn.value))

  /**
   * @param {string} value
   * @returns {void}
   */
  function setActiveAppModal(value) {
    activeAppModal.value = value
  }

  /**
   * @param {string} [value]
   * @returns {void}
   */
  function setActiveAppModalTransition(value = 'fade') {
    activeAppModalTransition.value = value
  }

  /**
   * @param {Object} value
   * @returns {void}
   */
  function setActiveAppModalOptions(value) {
    activeAppModalOptions.value = value
  }

  /**
   * @param {string} value
   * @returns {void}
   */
  function setActiveAppTray(value) {
    activeAppTray.value = value
  }

  /**
   * @param {string} [value]
   * @returns {void}
   */
  function setActiveAppTrayTransition(value = 'app-tray-transition') {
    activeAppTrayTransition.value = value
  }

  /**
   * @param {Object} value
   * @returns {void}
   */
  function setActiveAppTrayOptions(value) {
    activeAppTrayOptions.value = value
  }

  /**
   * @param {string} value
   * @returns {void}
   */
  function setActiveFlyIn(value) {
    activeFlyIn.value = value
  }

  /**
   * @param {string} [value]
   * @returns {void}
   */
  function setActiveFlyInTransition(value = 'fly-in-transition') {
    activeFlyInTransition.value = value
  }

  /**
   * @param {Object} value
   * @returns {void}
   */
  function setActiveFlyInOptions(value) {
    activeFlyInOptions.value = value
  }

  /**
   * @param {Object} overlay
   * @param {Object} [overlay.desktop]
   * @param {Object} [overlay.mobile]
   * @param {Object} [overlay.settings]
   * @returns {void}
   */
  function setCurrentOverlay({ desktop: d, mobile: m, settings: s }) {
    desktop.value = d
    mobile.value = m
    settings.value = s
  }

  /**
   * @param {Object} options
   * @returns {void}
   */
  function setCurrentOverlayOptions(options) {
    settings.value.options = options
  }

  /**
   * @returns {void}
   */
  function closeAppModal() {
    activeAppModal.value = null
    activeAppModalOptions.value = null
    desktop.value = null
    mobile.value = null
    settings.value = null

    setTimeout(() => {
      activeAppModalTransition.value = null
    }, 500)
  }

  /**
   * @returns {void}
   */
  function closeAppTray() {
    activeAppTray.value = null
    activeAppTrayOptions.value = null
    desktop.value = null
    mobile.value = null
    settings.value = null

    setTimeout(() => {
      activeAppTrayTransition.value = null
    }, 500)
  }

  /**
   * @returns {void}
   */
  function closeFlyIn() {
    activeFlyIn.value = null
    activeFlyInOptions.value = null
    desktop.value = null
    mobile.value = null
    settings.value = null

    setTimeout(() => {
      activeFlyInTransition.value = null
    }, 500)
  }

  function setEventImagesModalIsActive(bool) {
    eventImagesModalIsActive.value = bool
  }

  return {
    settings,
    mobile,
    desktop,
    activeAppModal,
    activeAppModalTransition,
    activeAppModalOptions,
    activeAppTray,
    activeAppTrayTransition,
    activeAppTrayOptions,
    activeFlyIn,
    activeFlyInTransition,
    activeFlyInOptions,
    eventImagesModalIsActive,
    overlayIsActive,
    setActiveAppModal,
    setActiveAppModalTransition,
    setActiveAppModalOptions,
    setActiveAppTray,
    setActiveAppTrayTransition,
    setActiveAppTrayOptions,
    setActiveFlyIn,
    setActiveFlyInTransition,
    setActiveFlyInOptions,
    setCurrentOverlay,
    setCurrentOverlayOptions,
    closeAppModal,
    closeAppTray,
    closeFlyIn,
    setEventImagesModalIsActive,
  }
})
